import { sendBigQueryEvent, sendMixPanelEvent } from '../biEvents';
import { MP_VIDEO_CONTROLS_CLICKED } from '../biEvents/events/mixPanelEvents';
import { BQ_VIDEO_PAUSE, BQ_VIDEO_PLAY } from '../biEvents/events/bigQueryEvents';

interface VideoEventsHandlerProps {
    actionType: 'Pause' | 'Play';
    params?: Record<string, string | number>;
}

export const videoEventsHandler = ({ actionType, params }: VideoEventsHandlerProps) => {
    sendBigQueryEvent({ eventName: actionType === 'Pause' ? BQ_VIDEO_PAUSE : BQ_VIDEO_PLAY, params });
    sendMixPanelEvent({ eventName: MP_VIDEO_CONTROLS_CLICKED, params: { action: actionType, ...params } });
};
